import { application } from "./application"

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import LaunchController from "./launch_controller"
application.register("launch", LaunchController)
